import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTriggerOff(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M17.8113 10.8942L16.8475 12.4333L15.4373 11.0232L15.4519 11.0003H15.4145L12.9465 8.53236L15.4956 4.00008L8.41414 4L6.59401 2.17987C6.77965 2.06571 6.99738 2 7.23021 2H16.7677C17.7124 2 18.3046 3.03689 17.8359 3.87024L14.9506 9.00027H16.7567C17.7135 9.00027 18.3041 10.061 17.8113 10.8942Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.218 16.6323L18.5857 21C18.9762 21.3905 19.6094 21.3905 19.9999 21C20.3904 20.6095 20.3905 19.9763 19.9999 19.5858L4.41414 4C4.02361 3.60947 3.39045 3.60947 2.99992 4C2.6094 4.39052 2.6094 5.02369 2.99992 5.41421L5.99985 8.41414V12.7504C5.99985 13.4408 6.5507 14.0005 7.23021 14.0005L8.99985 14V20.7422C8.99985 22.0096 10.5951 22.478 11.2377 21.3917L14.218 16.6323ZM12.7827 15.197L10.9998 13.4141V18L12.7827 15.197ZM9.5861 12.0004H7.99985V10.4141L9.5861 12.0004Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
